import { Container, IDestroyOptions, Point, Sprite, Ticker } from "pixi.js";
import { CommonResourcesPackage } from "../../../../common/resources/CommonResourcesPackage";
import { ProgressBar } from "../../../../common/components/ProgressBar";
import { GameResourcesPackage } from "../../resources/GameResourcesPackage";
import { Character } from "../3d/character/Character";
import { nameof } from "bindable-data";

export class HealthBar extends Sprite {
    private readonly icon: Sprite;
    private readonly progressBar: ProgressBar;

    public get flyTargetCoordinates(): Point {
        const icon = this.icon;
        const gv = this.parent as Container;
        const lb = icon.getLocalBounds();
        const localCenter = new Point(lb.x + lb.width / 2, (lb.y + lb.height / 2) - 5);

        return gv ? gv.toLocal(localCenter, icon) : localCenter; // Convert from icon's local space to GameView's local space
    }

    public constructor(
        commonResources: CommonResourcesPackage,
        gameResources: GameResourcesPackage,
        private readonly character: Character
    ) {
        super(commonResources.assets_common_violet_placeholder_png);
        this.eventMode = "static";
        this.icon = new Sprite(gameResources.assets_game_ui_health_bar_health_icon_png);
        this.progressBar = new ProgressBar(
            gameResources.assets_game_ui_health_bar_base_background_png,
            gameResources.assets_game_ui_health_bar_bar_progress_png,
            1
        );
        this.progressBar.updateProgressPosition(
            (this.progressBar.background.width - this.progressBar.progress.width) * 0.5,
            (this.progressBar.background.height - this.progressBar.progress.height) * 0.5
        );

        this.icon.position.set(0, -2);
        this.progressBar.position.set(142, 34);
        this.addChild(this.icon, this.progressBar);
        this.character.propertyChanged.add(this.onCharacterHealthChange, this);
    }

    private onCharacterHealthChange(character: Character, key: string): void {
        if (key === nameof(character, "health")) {
            this.progressBar.value = character.health.value / 100;
        }
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        this.character.propertyChanged.remove(this.onCharacterHealthChange, this);
        super.destroy(options);
    }
}
